/* dataCommissionsSlice.js */
// Objetivo: mismo flujo de estados que reservations (idle → loading → partiallyLoaded → loaded)
// y almacenar cada año sin pisar los anteriores.

import { createSlice } from "@reduxjs/toolkit";
import { commissionsApi } from "./commissionsApi";

export const TOTAL_YEARS_NEEDED = 4;

const initialState = {
    status: "idle", // idle | loading | partiallyLoaded | loaded | reload | error
    data: {}, // { 2025: <payload>, 2024: <payload> ... }
    yearsLoaded: {}, // { 2025: true, 2024: true ... }
    extra: {}, // metadata opcional
    error: null,
};

const mergeYearPayload = (state, year, payload) => {
    // payload puede venir como { payload: {...}, extra: {...} }
    const body = payload.payload ?? payload;
    state.data[year] = body;
    if (payload.extra) state.extra = { ...state.extra, ...payload.extra };
    state.yearsLoaded[year] = true;
};

const slice = createSlice({
    name: "dataCommission",
    initialState,
    reducers: {
        // Por si quieres forzar un reset desde UI (doble click en la burbuja, etc.)
        resetCommissions: () => initialState,
    },
    extraReducers: (builder) =>
        builder
            // --- PENDING --------------------------------------------------------
            .addMatcher(
                commissionsApi.endpoints.getCommissions.matchPending,
                (state, { meta: { arg } }) => {
                    // primer pending → loading; si ya estaba loaded, marcamos reload
                    state.status =
                        state.status === "loaded" ? "reload" : "loading";
                    state.error = null;
                }
            )
            // --- FULFILLED ------------------------------------------------------
            .addMatcher(
                commissionsApi.endpoints.getCommissions.matchFulfilled,
                (state, { payload, meta }) => {
                    // meta.arg.originalArgs.year es el valor correcto
                    const year = meta?.arg?.originalArgs?.year;

                    console.log({ year, meta, payload });

                    if (year == null) return; // evita escribir en "undefined"

                    mergeYearPayload(state, year, payload);

                    const loadedYears = Object.keys(state.yearsLoaded).length;
                    state.status =
                        loadedYears >= TOTAL_YEARS_NEEDED
                            ? "loaded"
                            : "partiallyLoaded";
                }
            )
            // --- REJECTED -------------------------------------------------------
            .addMatcher(
                commissionsApi.endpoints.getCommissions.matchRejected,
                (state, { error }) => {
                    state.status = "error";
                    state.error = error;
                }
            ),
});

export const { resetCommissions } = slice.actions;
export default slice.reducer;
